import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';

const HistogramChart = ({ data, domain = [-1, 1], numBins = 25, c = 'steelblue', showAxes = true, addMargin = true }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        // Clear the canvas
        context.clearRect(0, 0, canvas.width, canvas.height);

        // Dimensions
        const width = canvas.width;
        const height = canvas.height;

        // Chart margins and dimensions
        const margin = addMargin ? { top: 10, right: 10, bottom: 12, left: 15 } : { top: 0, right: 0, bottom: 0, left: 0 };
        const chartWidth = width - margin.left - margin.right;
        const chartHeight = height - margin.top - margin.bottom;

        // Create histogram bins
        const bins = d3.bin()
            .domain(domain)
            .thresholds(numBins)(data.filter(d => d !== 0));

        // Scales
        const xScale = d3.scaleBand()
            .domain(bins.map((_, i) => i)) // Bin indices as domain
            .range([0, chartWidth])
            .padding(0.1);

        const maxY = d3.max(bins.map(b => b.length))
        const yScale = d3.scaleLinear()
            .domain([0, maxY])
            .range([chartHeight, 0]);

        const valueScale = d3.scaleLinear()
            .domain(domain)
            .range([0, chartWidth]);

        // Draw bins
        context.save();
        context.translate(margin.left, margin.top);

        bins.forEach((bin, i) => {
            const x = xScale(i);
            const y = yScale(bin.length);
            const binWidth = xScale.bandwidth();
            const binHeight = chartHeight - y;

            if (x !== undefined && y !== undefined) {
                context.fillStyle = c;
                context.fillRect(x, y, binWidth, binHeight);
            }
        });

        if (showAxes) {

            // Draw X and Y Axes
            context.strokeStyle = '#ccc';
            context.lineWidth = 1;

            // X-Axis
            context.beginPath();
            context.moveTo(0, chartHeight);
            context.lineTo(chartWidth, chartHeight);
            context.stroke();

            // Y-Axis
            context.beginPath();
            context.moveTo(0, 0);
            context.lineTo(0, chartHeight);
            context.stroke();

            // Draw X-Axis Labels
            const xLabels = [-1, -0.5, 0, 0.5, 1];
            context.fillStyle = 'gray';
            context.textAlign = 'center';
            context.textBaseline = 'top';
            context.font = '8px Arial';

            xLabels.forEach(label => {
                const x = valueScale(label);
                if (x !== undefined && x >= 0 && x <= chartWidth) {
                    context.fillText(label, x, chartHeight + 5);
                }
            });

            // Draw Y-Axis Labels
            context.textAlign = 'right';
            context.textBaseline = 'middle';
            const yLabels = [0, maxY];
            yLabels.forEach(label => {
                const y = yScale(label);
                if (y !== undefined && y >= 0 && y <= chartHeight) {
                    context.fillText(label, -5, y);
                }
            });

            // Add X-Axis Title
            // context.font = '10px Arial';
            // context.textAlign = 'center';
            // context.fillText("M_score", chartWidth / 2, chartHeight + 20);

            // Add Y-Axis Title
            // context.save();
            // context.translate(-25, chartHeight / 2);
            // context.rotate(-Math.PI / 2);
            // context.fillText("Children", 0, 0);
            // context.restore();
        }

        context.restore();
    }, [data, numBins]);

    return (
        <canvas
            ref={canvasRef}
            width={180}
            height={60}
        // style={{ border: '1px solid black' }}
        />
    );
};

export default HistogramChart;
